import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { IMenu } from '@core/models/interfaces/menu.interface';

@Component({
  selector: 'app-menu-mobile',
  standalone: true,
  imports: [CommonModule, RouterModule, BsDropdownModule, FontAwesomeModule],
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss'],
})
export class MenuMobileComponent {
  @Input() userInfo!: { isLoggedIn: boolean; userFirstName: string | null };
  @Input() userMenu: IMenu[] = [];
  @Input() set principalMenu(values: IMenu[]) {
    if (values) {
      this.menu = this.sortByOrder([...values]);
      this.sortSubMenuByOrder(this.menu);
    }
  }

  @Output() logout = new EventEmitter<void>();

  menu: IMenu[] = [];
  faChevronRight = faChevronRight;
  faBars = faBars;

  constructor(private router: Router) {}

  redirectTo(item: IMenu): void {
    this.router.navigate([`${item.url}`]);
  }

  onLogout(): void {
    this.logout.emit();
  }

  sortByOrder(values: IMenu[]): IMenu[] {
    values.sort((a: IMenu, b: IMenu) => a.order - b.order);
    return values;
  }

  sortSubMenuByOrder(menuList: IMenu[]): IMenu[] {
    menuList.forEach(item => {
      if (item.submenus) {
        item.submenus = this.sortByOrder(item.submenus);
      }
    });
    return menuList;
  }
}
